import { render } from "./gillscreek_popup.vue?vue&type=template&id=1827a65e&scoped=true"
import script from "./gillscreek_popup.vue?vue&type=script&lang=js"
export * from "./gillscreek_popup.vue?vue&type=script&lang=js"

import "./gillscreek_popup.vue?vue&type=style&index=0&id=1827a65e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1827a65e"]])

export default __exports__